import React from "react";

const Container = ({ children }) => {
  return (
    <div className="flex flex-1 flex-col">
      <main className="bg-white flex-1 p-3 overflow-hidden items-center justify-center">
        {children}
      </main>
    </div>
  );
};

export default Container;
